// noop is No Operation function for some undefined props
export const noop = () => {};
